import AgreementStatus from "../_AgreementStatus";
import ErrorPage from "../_ErrorPage";

export default {
  ...ErrorPage.actions,
  ...AgreementStatus.actions
};
